
import React from "react";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {EditElementModalForm} from "../EditElementModalForm";

export class EditCommentsForm extends EditElementModalForm {

    constructor(props) {
        super(props);
        this.state = {
            comments: this.props.comments,
            loading: false,
            saving: false
        };

        this.handleCommentsChange = this.handleCommentsChange.bind(this);
    }

    getSubmitUrl() {
        if(this._isEditingCampaignComment())
            return API_URL + `campaigns-configurations/${this.props.campaignsConfigurationId}/campaigns/${this.props.campaignId}/comments/`;
        else if(this._isEditingAdgroupComment())
            return API_URL + `campaigns-configurations/${this.props.campaignsConfigurationId}/adgroups/${this.props.adgroupId}/comments/`;
        else if(this._isEditingBusinessUnitComment())
            return API_URL + `business-unit/${this.props.businessUnitId}/comments/`;
        else if(this._isEditingCampaignsConfigurationComment())
            return API_URL + `campaigns-configurations/${this.props.campaignsConfigurationId}/comments/`;
        else
            throw new Error("Entity not supported");
    }

    _isEditingCampaignComment() {
        return this.props.campaignId !== undefined && this.props.campaignId != null;
    }

    _isEditingAdgroupComment() {
        return this.props.adgroupId !== undefined && this.props.adgroupId != null;
    }

    _isEditingBusinessUnitComment() {
        return this.props.businessUnitId !== undefined && this.props.businessUnitId != null && !this._isEditingCampaignComment() && !this._isEditingCampaignsConfigurationComment();
    }

    _isEditingCampaignsConfigurationComment() {
        return this.props.campaignsConfigurationId !== undefined && this.props.campaignsConfigurationId != null && !this._isEditingCampaignComment();
    }

    getDataToSubmit(event) {
        return {'text': this.state.comments};
    }

    renderSaveButton() {
        if (this.state.saving === false) {
            return <input type="submit" value="Guardar" className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    handleCommentsChange = (event) => {
        this.setState({
            comments: event.target.value
        });
    };

    renderFormFields() {
        if (this.state.loading === true) {
            return <Spinner color="positive small"/>;
        }

        return <div className="modal-section">
            <div className="form-row mb-0 pb-0">
                <label>Comentario:</label>
            </div>
            <div className="form-row">
                <textarea
                    name="comment"
                    className="form-control"
                    id="comments"
                    value={this.state.comments}
                    onChange={this.handleCommentsChange}
                />
            </div>
        </div>;
    }
}
